const ENV_COOKIE_DOMAIN = process.env.REACT_APP_COOKIE_DOMAIN;
const IS_LOCALHOST_OVERRIDE = process.env.REACT_APP_IS_LOCALHOST === 'true';

function detectLocalhost(): boolean {
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname;
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.endsWith('.local')
  );
}

const isLocalhost = IS_LOCALHOST_OVERRIDE || detectLocalhost();
const COOKIE_DOMAIN = isLocalhost ? '' : ENV_COOKIE_DOMAIN;
const SAME_SITE = isLocalhost ? 'lax' : 'none';
const SECURE = !isLocalhost;

export function setCookie(name: string, value: string, seconds?: number) {
  if (!isLocalhost && !ENV_COOKIE_DOMAIN) {
    throw new Error('REACT_APP_COOKIE_DOMAIN must be set in production');
  }

  let expires = '';
  if (seconds !== undefined && seconds !== null) {
    const date = new Date();
    date.setTime(date.getTime() + seconds * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }

  const domainStr = COOKIE_DOMAIN ? `; domain=${COOKIE_DOMAIN}` : '';
  const pathStr = '; path=/';
  const sameSiteStr = `; SameSite=${SAME_SITE}`;
  const secureStr = SECURE ? '; Secure' : '';

  document.cookie = `${name}=${value}${expires}${pathStr}${domainStr}${sameSiteStr}${secureStr}`;
}

export function getCookie(name: string): string | null {
  const nameEQ = name + '=';
  const cookies = document.cookie.split(';');

  for (let c of cookies) {
    c = c.trim();
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
  }

  return null;
}
